export const getImageUrl = (image: any) => {
  return typeof image === 'string' ? image : image.src;
};
